// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"HW-z","sponsoredTooltipWrapper":"IW-z","sponsoredTooltip":"JW-z","newCard":"KW-z"};